import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

type Props = {
  open: boolean;
  message: string;
  onClose: () => void;
};

const SubscriptionPaymentIssueModal: React.FC<Props> = ({ open, message, onClose }) => (
  <Modal
    title={
      <span>
        <ExclamationCircleOutlined style={{ color: 'var(--warning)', marginRight: 8 }} />
        Ödeme bilgisi
      </span>
    }
    open={open}
    onOk={onClose}
    onCancel={onClose}
    okText="Tamam"
    cancelButtonProps={{ style: { display: 'none' } }}
    destroyOnClose
  >
    <p style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{message}</p>
  </Modal>
);

export default SubscriptionPaymentIssueModal;
